import 'library/styles/components/form-elements/select-with-other.scss';
import React from 'react';
import { InputEvent } from 'library/helpers/synthetic-events';

const MapSelectOptions = (values) => {
  const out = [
    <option key="choose-one" value="">-- Choose One --</option>
  ];

  for (let key in values) {
    out.push(
      <option key={key} value={key}>
        { values[key] }
      </option>
    );
  }

  return out;
};

export default class SelectWithOther extends React.Component {
  constructor(props, ...params) {
    super(props, ...params);

    let { value, values } = props;

    if (value !== '' && !values.hasOwnProperty(value)) {
      value = 'other';
    }

    this.state = {
      value: value
    };
  }

  componentWillReceiveProps(nextProps) {
    let { value, values } = nextProps;

    if (value === '') {
      return;
    }

    if (!values.hasOwnProperty(value)) {
      value = 'other';
    }

    if (this.state.value !== value) {
      this.setState({
        value: value
      });
    }
  }

    handleChange = (e) => {
      let { name, value } = e.currentTarget;

      this.setState({
        value: value
      });

      if (value === 'other') {
        value = '';
      }

      this.props.onChange(new InputEvent({
        value: value,
        name: name
      }));
    }

    renderOther = () => {
      if (this.state.value === 'other') {
        return <input type="text" {...this.props} autoFocus={true} />;
      }
      return null;
    }

    render() {
      const { children, values, ...props } = this.props;
      return (
        <span className="select-with-other">
          <select {...props} value={this.state.value} onChange={this.handleChange}>
            { MapSelectOptions(values) }
            <option value="other">other</option>
          </select>
          { this.renderOther() }
        </span>
      );
    }
}
